import(/* webpackMode: "eager", webpackExports: ["KnowledgeHubListView"] */ "/vercel/path0/frontend_next/src/components/views/KnowledgeHubListView.tsx");
